<template>
    <div class="sign">

        <div class="marryPhone" v-if="marryPhone">为了体验更多功能请绑定手机号：</div>

        <div :class="{tele: true, tele_login: path != 'login'}">
            <div class="phone">
                <span>+86</span><input type="text" placeholder="请输入手机号码" v-model="phone">
            </div>
            <div class="code">
                <input type="text" placeholder="请输入验证码" class="text" v-model="coodText"> <button type="button" v-text="btnText + min" class="btn" @click="getCood"></button>
            </div>

            <button type="button" class="login" @click="login" v-text="login_text"></button>
        </div>
        <div class="wechat" v-if="path == 'login' && !marryPhone && $store.state.is_wx">
            <div class="title">使用以下方式登录</div>
            <div class="img">
                <img :src="$store.state.api.imgUrl + 'wechat.png'" alt="" @click="wechat">
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.sign{
    background-color: #fff;
    width: 375px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    input::-webkit-input-placeholder{
        font-family: SourceHanSansCN-Light;
        font-size: 13px;
        font-weight: 100;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #cecece;
        border-radius: 0;
    }
    .marryPhone{
        width: 245px;
        height: 16px;
        font-family: SourceHanSansCN-Normal;
        font-size: 16px;
        font-weight: 100;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        transform: translateY(-32px);
        text-align: left;
    }
    

    .tele{
        width: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .phone{
            width: 100%;
            border-bottom: 1px solid #ccc;
            display: flex;
            align-items: center;
            span{
                display: inline-block;
                width: 14%;
                font-size: 15px;
                height: 25px;
                
                line-height: 25px;
                font-family: DINCond-LightAlternate;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #000033;
            }
            input{
                width: 86%;
                font-family: DINCond-LightAlternat;
                padding-left: 5px;
                height: 25px;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #000033;
                border-radius: 0;
            }

        }

        .code{
            margin-top: 12px;
            width: 100%;
            
            .text{
                width: 67%;
                border: 0 none;
                border-radius: 0;
                border-bottom: 1px solid #ccc;
                margin-right: 5%;
                font-size: 15px;
                color: #000033;
                background-color: none;
            }
            .btn{
                width: 28%;
                height: 25px;
                line-height: 28px;
                text-align: center;
                background-color: #0690db;
                border-radius: (3px/2);
                font-family: SourceHanSansCN-Light;
                font-size: 12px;
                font-weight: 100;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ffffff;
            }
        }

        .login{
            margin-top: 30px;
            width: 100%;
            height: 35px;
            line-height: 38px;
            font-family: SourceHanSansCN-Light;
            font-size: 16px;
            font-weight: 100;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
            background-color: #0690db;
	        border-radius: (35px/2);
        }
    }
    .tele_login{
        width: 345px;
        .code{
            .btn{
            width: 20%;
            }
            .text{
                width: 77%;
                border-bottom: 1px solid #ccc;
                margin-right: 3%;
                font-size: 13px;
                border-radius: 0;
            }
        }
        
        .login{
            border-radius: 2px;
        }
  
    }

    .wechat{
        margin-top: 54px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
            padding: 0 8px;
            width: 100px;
            height: 11px;
            font-family: SourceHanSansCN-Light;
            font-size: 12px;
            font-weight: 100;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            background-color: #fff;
            transform: translateY(6px);
        }
        .img{
            padding-top: 20px;
            width: 206px;
            border-top: 1px solid #999;
            img{
                width: 30px;
                height: 35px;
            }
        }
    }
    
}
</style>
<script>
    import api from '@/utils/js/api.js'
    import { Toast } from 'vant';
    import qs from 'qs';

    export default {
        data(){
          return {
            show:1,
            phone: '',
            coodText: '',
            btnText: '获取验证码',
            login_text: '登录',
            min: '',
            cood:'',
            marryPhone: false,
            params: '',
            token: '',
            userInfo: ''
          }
        },
        name: 'sign',
        props: {
            msg: String,
            path: String
        },
        created(){
            console.log('判断微信登录重定向',this.$route);
            this.params = this.$route.params;
            if(this.$route.query.code){
                localStorage.removeItem('get_openid');
                this.wechat_code(this.$route.query.code)
            }else{
                this.save_userInfo(this.params.bindPhone);
            }
        },
        beforeMount(){
            // console.log(this.msg, this.params.login_text);
            if(this.msg) this.login_text = this.msg;
            if(this.params.login_text) this.login_text = this.params.login_text;
        },
        methods:{
            // 存userInfo
            save_userInfo(msg){
                this.token = localStorage.getItem('token');
                this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
                if(this.token && this.userInfo){
                    this.$store.commit({
                        type: 'getUserInfo',
                        must: true
                    })

                    if(msg && !this.userInfo.phone){
                        this.marryPhone = msg;
                        this.$emit('back');
                    }else{
                        this.$emit('sign');
                    }
                    
                }
            },
            // RSA加密
            RSA(str){
                if(!str) return;
                var Encrypt = new JSEncrypt();
                Encrypt.setPublicKey(api.RES_PUBLIC_KEY);
                console.log(Encrypt.encrypt(str).toLocaleUpperCase());
                return Encrypt.encrypt(str).toLocaleUpperCase();
            },
            // 获取验证码
            getCood($event){
                if(this.btnText !== '获取验证码') return;
                if(!(/^1[3-9]\d{9}$/.test(this.phone))){
                    Toast('手机号码有误')
                    return;
                }
                this.$http({
                    url: api.sendCode,
                    method: 'post',
                    data: {
                        phone: this.RSA(this.phone)
                    }
                }).then(res=>{
                    console.log('sendCode',res);
                    if(res.success){
                        this.cood = res.data;
                        this.btnText = 60;
                        this.min = ' s'
                        var timer;
                        timer = setInterval(()=>{
                            this.btnText = this.btnText - 1;
                            if(this.btnText == 0){
                                this.min = '';
                                this.btnText = '获取验证码';
                                clearInterval(timer);
                            }
                        },1000)
                    }else{
                        Toast(res.message);
                    }
                })
                
            },
            // 登录
            login(){
                if(!this.cood){
                    Toast('请先获取验证码');
                    return;
                }
                if(!this.phone){
                    Toast('请输入手机号');
                    return;
                }else if(!(/^1[3-9]\d{9}$/.test(this.phone))){
                    Toast('手机号码有误')
                    return;
                }
                if(!this.coodText){
                    Toast('请输入验证码');
                    return;
                }
                console.log('login');
                var url = api.login;
                var data = {
                    phone: this.RSA(this.phone),
                    code: this.coodText
                }
                var openId = this.userInfo.publicOpenid || localStorage.getItem('openid');
                // if(this.userInfo && this.token && this.path == 'login'){
                //     url = api.bindPhone;
                // }
                if(this.login_text == "绑定手机"){
                    console.log('绑定手机555')
                    url = api.bindPhone;
                    data.unionId = this.$store.state.userInfo.unionid || JSON.parse(localStorage.getItem('userInfo')).unionid;
                }
                data.openId = this.RSA(openId);
                this.$http({
                    url: url,
                    method:'post',
                    data: data
                }).then(res=>{
                    if(res.success){
                        localStorage.setItem('token',res.data.token);
                        localStorage.setItem('userInfo',JSON.stringify(res.data));
                        this.$store.commit({
                            type: 'getUserInfo',
                            must: true
                        });
                        setTimeout(()=>{
                            if(this.params.name){
                                // this.$emit('back');
                                this.$router.replace({
                                    name: this.params.name
                                })
                            }else if(this.path != 'login'){
                                this.$emit('opt');
                                this.show = 0;
                            }else{
                                this.$router.replace({
                                    name: 'index',
                                })
                            } 
                        },1100)
                    }
                    this.$toast(res.message)
                })

            },
            //微信授权取code
            wechat(){
                console.log('wechat-login');
                var data ={
                        appid: 'wxe6d64706308fd8b3',
                        // redirect_uri: encodeURI('http://www.pantaoys.com/h5/login'),
                        redirect_uri: encodeURI(window.location.href + '?' + qs.stringify(this.params)),
                        response_type: 'code',
                        scope: 'snsapi_userinfo',
                        state: (new Date()).valueOf(),
                }
                localStorage.setItem('get_openid', '1');
                location.href = api.wechat_auth + `?${qs.stringify(data)}#wechat_redirect`;
            },
            // 微信登录公众号
            wechat_code(_code){
                this.$http({
                    url: api.weChatOpenAccountLogin,
                    method: 'post',
                    data: {
                        code: _code
                    }
                }).then(res=>{
                    console.log('weChatOpenAccountLogin',res)
                    if(res.success){
                        localStorage.setItem('token',res.data.token);
                        localStorage.setItem('userInfo',JSON.stringify(res.data));
                        this.login_text = "绑定手机";
                        this.save_userInfo(true)
                    }else{
                        this.$toast(res.message);
                    }
                    
                })
            }
        }
    }
</script>


